var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.485,
    height: 88.557,
    viewBox: "0 0 297.485 88.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 2.294, 27.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M963.607,622.628s12.255,13.694,23.193,14.414,13.573-30.03,22.666-31.712,6.852,29.309,23.192,29.309,22.929-23.784,46.385-18.739,20.821,38.438,47.44,43.724,24.774-29.309,43.222-28.348,13.177-19.7,25.828-22.1,18.448,11.531,31.626,6.727,25.3-15.375,25.3-15.375",
    transform: "translate(-963.607 -600.526)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 10.21,
    cy: 9.643,
    rx: 10.21,
    ry: 9.643,
    transform: "translate(222.428 0.285)",
    fill: "#85d5b2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 3.97,
    cy: 3.97,
    r: 3.97,
    transform: "translate(228.56 5.957)",
    fill: "#85d5b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.aee2f789acf5b61e9dc78647189315b0.svg";
export { ForwardRef as ReactComponent };